module.exports = __webpack_public_path__ + "img/person-from-portal.56d27c91.svg";